/**
 * A sample granite that needs no network: a seamless tile of mottled grey with light and dark specks,
 * generated by an SVG filter and inlined as a data URI. It stands in when the catalogue cannot be
 * reached, so the scenes still show a believable stone instead of an empty room.
 */
const SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="320" height="320">
<filter id="g" x="0" y="0" width="100%" height="100%" color-interpolation-filters="sRGB">
<feTurbulence type="fractalNoise" baseFrequency="0.016" numOctaves="4" seed="4" stitchTiles="stitch" result="cloud"/>
<feColorMatrix in="cloud" type="matrix" values="0 0 0 0 0.43  0 0 0 0 0.42  0 0 0 0 0.4  0 0 0 1.4 -0.35" result="mottle"/>
<feTurbulence type="fractalNoise" baseFrequency="0.9" numOctaves="2" seed="11" stitchTiles="stitch" result="grain"/>
<feColorMatrix in="grain" type="matrix" values="0 0 0 0 0.94  0 0 0 0 0.92  0 0 0 0 0.88  0 0 0 11 -6.6" result="light"/>
<feColorMatrix in="grain" type="matrix" values="0 0 0 0 0.06  0 0 0 0 0.06  0 0 0 0 0.07  0 0 0 -11 4.6" result="dark"/>
<feMerge><feMergeNode in="mottle"/><feMergeNode in="light"/><feMergeNode in="dark"/></feMerge>
</filter>
<rect width="320" height="320" fill="#5d5b58"/>
<rect width="320" height="320" filter="url(#g)"/>
</svg>`;

/** `data:` URI of the sample tile (percent-encoded, safe inside `url("…")`). */
export const NEUTRAL_STONE_URL = `data:image/svg+xml,${encodeURIComponent(SVG.replace(/\n/g, ''))}`;

/** Average colour of the sample, used where only a flat tint is drawn (picker thumbnails). */
export const NEUTRAL_STONE_TINT = '#6a6865';
